import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import img1 from "../assets/images/noimage.jpg";
import { MyApi } from "../MyApi";
import useSEO from "../hooks/useSEO";

export default function BlogAll() {
  // States
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // ✅ SEO Hook (top-level)
  useSEO({
    title:
      "Maa Pateswari University, Balrampur – Courses, Admissions & Latest Updates",
    description:
      "Explore Maa Pateswari University, Balrampur – Find detailed information about courses, admissions, departments, and latest news & updates from MPUB. Stay informed about academic programs and events at Balrampur's leading university.",
    keywords:
      "Maa Pateswari University, Balrampur University, MPUB courses, MPUB admissions, Balrampur education, university news, MPUB updates, higher education Balrampur",
    canonical: window.location.href,
  });

  // Helpers
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const stripHTML = (html = "") => html.replace(/<[^>]*>?/gm, "");

  const limitWords = (text, limit = 55) => {
    if (!text) return "";
    const cleanText = stripHTML(text).replace(/\s+/g, " ").trim();
    const words = cleanText.split(" ");
    return words.length > limit
      ? words.slice(0, limit).join(" ") + "..."
      : cleanText;
  };

  // Fetch blogs
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + MyApi.BLOGALLLIST, {
          headers: { Authorization: MyApi.SECRET_KEY },
        });
        if (res.data?.status) setServices(res.data.data || []);
      } catch (error) {
        console.error("Blog API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) return <p className="text-center py-5">Loading blogs...</p>;

  // Pagination logic
  const totalPages = Math.ceil(services.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentBlogs = services.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="bg_image experts">
      <div className="BreadcrumbStyle">
             <Container>
                <h1>Latest News & Blogs</h1>
                <Breadcrumb>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                   <Breadcrumb.Item active>Latest News & Blogs</Breadcrumb.Item>
                </Breadcrumb>
              </Container>
          </div> 
      <Container>
        <div className="servi_bx"> 

          {currentBlogs.length > 0 ? (
            currentBlogs.map((item, index) => {
              if (!item?.product || !item?.parent_category) return null;

              const product = item.product;
              const category = item.parent_category;

              return (
                <div className="blog-row mb-4" key={product.id || index}>
                  <Row className="align-items-center">
                    {/* LEFT IMAGE */}
                    <Col md={4}>
                      <Link to={`/${category.categoryurl}/${product.producturl}`}>
                        <img
                          src={product.image_url || img1}
                          alt={product.productname}
                          className="img-fluid blog-row-img"
                          onError={(e) => (e.target.src = img1)}
                        />
                      </Link>
                    </Col>

                    {/* RIGHT CONTENT */}
                    <Col md={8}>
                      <div className="blog-row-content">
                        <span className="blog-date">
                          {formatDate(product.created_on)}
                        </span>

                        <Link to={`/${category.categoryurl}/${product.producturl}`}>
                          <h3>{product.productname}</h3>
                        </Link>

                        {product.productcontent && (
                          <p className="blog-excerpt">
                            {limitWords(product.productcontent, 55)}
                          </p>
                        )}

                        <Link
                          to={`/${category.categoryurl}/${product.producturl}`}
                          className="read-more"
                        >
                          Read More →
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })
          ) : (
            <p className="text-center">No blogs found</p>
          )}

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="pagination-wrapper text-center mt-4">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Prev
              </button>

              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  className={currentPage === i + 1 ? "active" : ""}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}
